import * as React from 'react';

import { saveReview } from '../../../actions/classroomSessions';
import useModalAccessibility from '../../../../Shared/hooks/useModalAccessibility'

const CongratulationsModal = ({ closeModal, lessonId, classroomSessionId, }) => {
  const { modalRef, } = useModalAccessibility(closeModal)

  const [selectedEmoji, setSelectedEmoji] = React.useState(null)

  function selectEmoji(value: number) {
    setSelectedEmoji(value)

    if (classroomSessionId) {
      saveReview(lessonId, classroomSessionId, value)
    }
  }

  const renderFeedbackResponse = () => {
    let text
    if (selectedEmoji === 2) {
      text = <p>We are happy to hear that you had a good experience with Quill Lessons. Please share your feedback, suggestions or report any bugs by clicking on the link below.</p>
    } else {
      text = <p>We are sorry to hear that you did not have a good experience with Quill Lessons. Please share your feedback, suggestions or report any bugs by clicking on the link below.</p>
    }
    return (
      <div className="feedback-response">
        <p>Thank you!</p>
        {text}
        <a href="https://goo.gl/forms/n5xkhRBMg8V4v0Fj1" rel="noopener noreferrer" target="_blank">Share Your Feedback</a>
      </div>
    )
  }

  const renderFeedbackSection = () => {
    if (selectedEmoji !== null) { return renderFeedbackResponse() }
    return (
      <div className="feedback-section">
        <p className="feedback-question">How was your experience with Quill Lessons?</p>
        <div className="emoji-row">
          <button aria-label="Disappointed" className="emoji-button focus-on-light" onClick={() => selectEmoji(0)} type="button"><span aria-hidden="true">😞</span></button>
          <button aria-label="Neutral" className="emoji-button focus-on-light" onClick={() => selectEmoji(1)} type="button"><span aria-hidden="true">😐</span></button>
          <button aria-label="Love it" className="emoji-button focus-on-light" onClick={() => selectEmoji(2)} type="button"><span aria-hidden="true">😍</span></button>
        </div>
      </div>
    )
  }

  return (
    <div className="congratulations-modal-container">
      <div className="congratulations-modal-background" />
      <div
        aria-labelledby="congratulations-modal-title"
        aria-modal="true"
        className="congratulations-modal"
        ref={modalRef}
        role="dialog"
        tabIndex={-1}
      >
        <div className="modal-header">
          <h2 id="congratulations-modal-title">Congratulations!<br />You&#39;ve completed a Quill Lessons Activity</h2>
          <p>This lesson will be marked as complete for your students. Your students&#39; answers in this lesson are now saved in the <strong>Activity Analysis</strong> reports.</p>
        </div>
        <div className="modal-divider" />
        {renderFeedbackSection()}
      </div>
    </div>
  )
}

export default CongratulationsModal
